<script lang="ts">
	import { getChatContext } from '#src/contexts/chat.context.svelte.ts';
	import SourceBadge from '#lib/SourceBadge.svelte';

	interface Props {
		hashes: string[];
		text: string;
	}

	let { hashes, text }: Props = $props();

	const chatCtx = getChatContext();

	const infos = $derived(
		hashes.flatMap((hash) => {
			const info = chatCtx.getCitationInfo(hash);
			return info ? [{ hash, ...info }] : [];
		})
	);

	const firstColor = $derived(infos[0]?.source.citation_color);
</script>

{#if infos.length > 0}
	<span data-hash={hashes[0]} class="source-highlight-wrap">
		<span class="highlight" style="background-color: {firstColor}">
			{#each infos as { source, occurrence } (occurrence.hash)}
				<SourceBadge
					appearance="minimal"
					badge={{
						color: source.citation_color,
						index: source.citation_index,
						subIndex: occurrence.sub_index
					}}
				/>
			{/each}
			{text}
		</span>
	</span>
{/if}

<style lang="scss">
	.source-highlight-wrap {
		display: inline;
	}

	.highlight {
		border-radius: 0.25rem;
		padding: 0.125rem 0.25rem;
	}
</style>
